import {connect} from 'react-redux';

import {wrapActionCreator} from '../../../../helpers/reduxHelpers';
import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {Dispatch} from '../../../../store/appStore';
import {createTagAction} from '../../../../store/data/tags/saveTagActions';
import {getUserNamespace} from '../../../../store/data/teammates/teammatesSelectors';
import {CreateWorkspaceTagDropdown} from './createWorkspaceTagDialog';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  userNamespace: getUserNamespace,
}));

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    createTagAction: wrapActionCreator(dispatch, createTagAction),
  };
}

export const CreateWorkspaceTagDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    createTagAsync: dispatchProps.createTagAction,
  }),
)(CreateWorkspaceTagDropdown);
